// extracted by mini-css-extract-plugin
export default {"container":"MailchimpForm_container__Ho3vE","error":"MailchimpForm_error__lgWQH"};